var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMortarPestle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.88,57.05c-3.61-3.47-4.75-8.22-3.09-13.33a13.16,13.16,0,0,1,16.69-8.55,13.47,13.47,0,0,1,8.42,16.95c-1.69,5.22-5.68,8.82-10.73,9.32m-.14,0-5.82,18m-12.1,0,7-21.62m17.51,38s-15.51,36.79,0,75.32M73.8,95.72s15.52,36.79,0,75.32M84.72,95.72H64V79.37H156V95.72H134.72m-1.15,75.9H156V188H64V171.62H85.87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortarPestle);
export default __webpack_public_path__ + "static/media/MORTAR_PESTLE.f6dabe2dc1a81a00f91449af58715088.svg";
export { ForwardRef as ReactComponent };